export enum Direction {
    Stay = 0,
    Up,
    Down,
    Left,
    Right
}

export enum CellMode {
    Empty,
    BreakableBarrier, // Можно разрушить путем атаки
    UnbreakableBarrier, // Не разрушаемая стена
}

export enum ActionMode {
    /** Просто передвинутся или стоять на месте */
    Move,
    /** Использовать, либо атаковать. Порядок следующий
     * 1. Атакуем, если есть бот на этой клетке
     * 2. Если барьер, разрушаем
     * 3. Едим органику
     * 4. Используем энергию
     * 5. Если ничего из этого нет, стоим
     */
    Use,
    /** Передать энергию или сделать свою копию (если на пустую клетку). Если на месте, энергия теряется   */
    Transfer,
}

